export const updateQueryParams = (key: string, value: string): string => {
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set(key, encodeURIComponent(value));
  var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
  history.pushState(null, '', newRelativePathQuery);
  return newRelativePathQuery;
}

export const isActivePath: (path: string) => boolean = path => path == window.location.pathname;

export function scrollToTop() {
  window.scrollTo(0, 0)
}
